module.exports = __webpack_public_path__ + "static/media/Rectangle26.2db84080.png";